import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, SizeTypeTokens, StackHeight, StackWidth, StepperTypeTokens, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../../routes';
import { horizontalStepperRepo } from '../../../../configs/utils';
import { ACTION } from './types';
import { GoBack, NavToBorrowerPanDetails } from './action';
import { Platform } from "react-native";
export const template = stepper => {
    return {
        layout: {
            id: ROUTE.CO_BORROWER_LANDING,
            type: LAYOUTS.LIST,
            widgets: [
                Platform.OS === "ios" ? { id: "spaceXXL", type: WIDGET.SPACE, position: POSITION.ABSOLUTE_TOP } : {},
                {
                    id: 'header',
                    type: WIDGET.HEADER,
                    position: POSITION.ABSOLUTE_TOP,
                },
                { id: 'space0', type: WIDGET.SPACE },
                { id: 'detailTitle', type: WIDGET.TEXT },
                { id: 'space1', type: WIDGET.SPACE },
                { id: 'description', type: WIDGET.TEXT },
                { id: 'space2', type: WIDGET.SPACE },
                { id: 'infoCard', type: WIDGET.STACK },
                {
                    id: 'bottomStack',
                    type: WIDGET.STACK,
                    position: POSITION.ABSOLUTE_BOTTOM,
                },
            ],
        },
        datastore: {
            header: {
                id: 'bt_coBorrowerLanding_goBack',
                title: 'Joint holder details',
                type: HeaderTypeTokens.verification,
                stepperProps: {
                    data: stepper,
                    type: StepperTypeTokens.HORIZONTAL,
                },
                action: {
                    type: ACTION.GO_BACK,
                    routeId: ROUTE.CO_BORROWER_LANDING,
                    payload: {},
                },
            },
            space0: {
                size: SizeTypeTokens.MD,
            },
            detailTitle: {
                label: 'Complete KYC for joint holder',
                fontFamily: FontFamilyTokens.Poppins,
                fontSize: FontSizeTokens.MD,
                color: ColorTokens.Grey_Night,
                fontWeight: '600',
                lineHeight: 24,
            },
            description: {
                label: 'For mutual funds owned as a joint holding (including anyone or either/or survivor), KYC details of joint holder are required.',
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.SM,
                color: ColorTokens.Grey_Charcoal,
                fontWeight: '400',
                lineHeight: 16,
            },
            space1: {
                size: SizeTypeTokens.MD,
            },
            space2: {
                size: SizeTypeTokens.XXXL,
            },
            infoCard: {
                height: StackHeight.CONTENT,
                width: StackWidth.CONTENT,
                padding: {
                    all: SizeTypeTokens.XL,
                },
                borderConfig: {
                    borderWidth: {
                        all: SizeTypeTokens.XS,
                    },
                    borderRadius: BorderRadiusTokens.BR2,
                    borderColor: ColorTokens.Grey_Chalk,
                },
                widgetItems: [
                    { id: 'accountIcon', type: WIDGET.IMAGE },
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'text1', type: WIDGET.TEXT },
                    { id: 'space4', type: WIDGET.SPACE },
                    { id: 'requireText', type: WIDGET.TEXT },
                ],
            },
            accountIcon: {
                uri: 'https://volt-images.s3.ap-south-1.amazonaws.com/co_applicant.png',
                width: 80,
                height: 80,
            },
            text1: {
                label: 'We require following details:',
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.SM,
                color: ColorTokens.Grey_Night,
                fontWeight: '500',
                lineHeight: 18,
            },
            space3: {
                size: SizeTypeTokens.XL,
            },
            space4: {
                size: SizeTypeTokens.LG,
            },
            requireText: {
                label: '\u2713 Basic details such as PAN & DOB \n\n\u2713 Document for KYC verification \n\n\u2713 Some additional information',
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.SM,
                color: ColorTokens.Grey_Charcoal,
                fontWeight: '400',
            },
            bottomStack: {
                height: StackHeight.CONTENT,
                width: StackWidth.MATCH_PARENT,
                widgetItems: [
                    { id: 'continueCTA', type: WIDGET.BUTTON },
                    { id: 'spaceBelowContinue', type: WIDGET.SPACE },
                ],
            },
            continueCTA: {
                id: 'bt_coBorrowerLanding_continue',
                label: 'Continue',
                type: ButtonTypeTokens.LargeFilled,
                width: ButtonWidthTypeToken.FULL,
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.MD,
                lineHeight: SizeTypeTokens.XXL,
                fontWeight: '700',
                action: {
                    type: ACTION.NAV_CO_BORROWER_PAN,
                    routeId: ROUTE.CO_BORROWER_LANDING,
                    payload: {},
                },
            },
            spaceBelowContinue: { size: SizeTypeTokens.MD },
            spaceXXL: { size: SizeTypeTokens.XXL },
        },
    };
};
export const coBorrowerLandingMF = {
    onLoad: async ({ instrumentTrack, network }) => {
        instrumentTrack("JOINT_HOLDER_KYC_START_PAGE_VIEWED");
        const stepper = await horizontalStepperRepo(network);
        return Promise.resolve(template(stepper));
    },
    actions: {
        [ACTION.GO_BACK]: GoBack,
        [ACTION.NAV_CO_BORROWER_PAN]: NavToBorrowerPanDetails,
    },
};
